<template>
  <div class="container-fluid">
    <div class="function-card">
      <button
        type="button"
        class="btn btn-danger"
        @click.prevent="getJobSetting"
      >
        重新整理
      </button>
    </div>

    <div class="yahome-table-wrap">
      <VueBootstrap4Table
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalData"
        @on-change-query="changePage"
      >
        <template slot="LastExecuteTime" slot-scope="props">
          {{ props.row.LastExecuteTime ? $common.dateTimeFormatter(props.row.LastExecuteTime) : null }}
        </template>

        <template slot="NextExecuteTime" slot-scope="props">
          {{ props.row.NextExecuteTime ? $common.dateTimeFormatter(props.row.NextExecuteTime) : null }}
        </template>

        <template slot="execute" slot-scope="props">
          <button
            type="button"
            class="btn btn-success btn-sm"
            style="margin-right: 0.5rem"
            @click="executeJobSetting(props.row.JobType)"
          >
            立即執行
          </button>
        </template>

        <template slot="setting" slot-scope="props">
          <button
            type="button"
            class="btn btn-info btn-sm"
            data-toggle="modal"
            data-target="#settingModal"
            @click="jobSettingTimeModal(props.row)"
          >
            排程時間設定
          </button>
        </template>

        <template slot="log" slot-scope="props">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            data-toggle="modal"
            data-target="#recordModal"
            @click="getJobRecord(props.row.JobType)"
          >
            執行紀錄
          </button>
        </template>
        <template slot="empty-results"> 暫無資料 </template>

        <template slot="switch" slot-scope="props">
          <el-switch
            active-color="#13ce66"
            inactive-color="#808080"
            v-model="props.row.Enabled"
            @change="updateJobSettingEnabled(props.row)"
          >
          </el-switch>
        </template>
        <template slot="empty-results"> 暫無資料 </template>
      </VueBootstrap4Table>
    </div>

    <!-- 取得LOG Modal -->
    <div
      id="logModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="role"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span>取得LOG</span>
            </div>
            <div class="modal-body">
              <div class="field">
                <ValidationProvider tag="div" name="日期" v-slot="{ errors }">
                  <label for=""> <span class="mark">*</span>選擇日期 </label>
                  <date-picker
                    class="w-100"
                    format="YYYY-MM-DD"
                    valueType="format"
                    placeholder="YYYY-MM-DD"
                  />
                  <span v-if="errors[0] && !is_composing" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(saveRole)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 排程時間 Modal -->

    <div
      id="settingModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="role"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span>排程時間設定</span>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-4">
                  <label for="select-time-type">
                    <span class="mark">*</span>
                    排程設定
                  </label>
                  <select
                    id="select-time-type"
                    class="form-control"
                    v-model="setting.JobTimeType"
                  >
                    <option value="Month">每月</option>
                    <option value="Week">每週</option>
                    <option value="Day">每日</option>
                  </select>

                  <label>
                    <input
                      type="radio"
                      name="timer"
                      :value="false"
                      v-model="setting.IsRepeatPeriod"
                    />
                    執行時間
                  </label>
                  <date-picker
                    v-model="setting.JobTimeSpan"
                    type="time"
                    format="HH:mm:ss"
                    value-type="format"
                    placeholder="請選擇"
                  />

                  <label>
                    <input
                      type="radio"
                      name="timer"
                      :value="true"
                      v-model="setting.IsRepeatPeriod"
                    />
                    重複執行每隔
                  </label>
                  <select
                    class="form-control"
                    v-model="setting.RepeatPeriodMinute"
                  >
                    <option value="0" disabled>請選擇</option>
                    <option value="1">1分鐘</option>
                    <option value="3">3分鐘</option>
                    <option value="5">5分鐘</option>
                    <option value="10">10分鐘</option>
                    <option value="15">15分鐘</option>
                    <option value="30">30分鐘</option>
                    <option value="60">60分鐘</option>
                  </select>
                </div>
                <div class="col-md-8">
                  <div class="month" v-if="setting.JobTimeType === 'Month'">
                    <label v-for="i in 31" :key="i">
                      <input
                        type="checkbox"
                        :value="i"
                        v-model="setting.JobDayOfMonth"
                      />
                      <span>{{ i }}</span>
                    </label>
                  </div>

                  <div class="week" v-if="setting.JobTimeType === 'Week'">
                    <label v-for="i in week" :key="i.value">
                      <input
                        type="checkbox"
                        :value="i.value"
                        v-model="setting.JobDayOfWeek"
                      />
                      <span>{{ i.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                data-dismiss="modal"
                @click="handleSubmit(updateJobSettingTime)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 執行紀錄 Modal -->
    <div
      id="recordModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver ref="role" class="modal-content" v-slot="{ reset }">
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span>執行紀錄</span>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-7 col-sm-12">
                  <div class="form-group">
                    <label for="">查詢日期</label>
                    <date-picker
                      class="w-100"
                      v-model="recordDate"
                      value-type="format"
                      format="YYYY-MM-DD"
                      type="date"
                      placeholder="請選擇"
                      @change="getJobRecord(choiceJobType)"
                    />
                  </div>

                  <div class="yahome-table-wrap">
                    <VueBootstrap4Table
                      :rows="recordList"
                      :columns="recordColumns"
                      :config="recordConfig"
                    >
                      <template slot="StartTime" slot-scope="props">
                        <div>
                          <span>
                            {{ $common.dateTimeFormatter(props.row.StartTime) }}
                          </span>
                        </div>
                      </template>

                      <template slot="EndTime" slot-scope="props">
                        <div>
                          <span>
                            {{ $common.dateTimeFormatter(props.row.EndTime) }}
                          </span>
                        </div>
                      </template>

                      <template slot="record" slot-scope="props">
                        <el-button
                          size="mini"
                          @click="record = { ...props.row }"
                        >
                          紀錄
                        </el-button>
                      </template>

                      <template slot="empty-results"> 暫無資料 </template>
                    </VueBootstrap4Table>
                  </div>
                </div>
                <div class="col-md-5 col-sm-12">
                  <span class="item-type">紀錄</span>
                  <div class="item-list">
                    <span v-if="record.Message">{{ record.Message }}</span>
                    <span v-else>尚未有資料</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import { config } from "@/components/back/table_config.js";

export default {
  name: "Schedule",

  components: {},
  data() {
    return {
      rows: [],
      totalData: 0,

      // 分頁資訊
      tableInfo: {
        page: 1,
        per_page: 10,
      },

      columns: [
        {
          label: "排程名稱",
          name: "JobName",
        },
        {
          label: "最近執行時間",
          name: "LastExecuteTime",
          slot_name: "LastExecuteTime",
        },
        {
          label: "下一次執行時間",
          name: "NextExecuteTime",
          slot_name: "NextExecuteTime",
        },
        {
          label: "操作",
          name: "execute",
          slot_name: "execute",
        },
        {
          label: "排程時間設定",
          name: "setting",
          slot_name: "setting",
        },
        {
          label: "執行紀錄",
          name: "log",
          slot_name: "log",
        },
        {
          label: "啟用",
          name: "switch",
          slot_name: "switch",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },

      setting: {
        type: "1",
      },
      week: [
        {
          label: "星期一",
          value: "1",
        },
        {
          label: "星期二",
          value: "2",
        },
        {
          label: "星期三",
          value: "3",
        },
        {
          label: "星期四",
          value: "4",
        },
        {
          label: "星期五",
          value: "5",
        },
        {
          label: "星期六",
          value: "6",
        },
        {
          label: "星期日",
          value: "0",
        },
      ],
      recordDate: "",
      recordList: [],
      record: {},
      recordColumns: [
        {
          label: "開始時間",
          name: "StartTime",
          slot_name: "StartTime",
        },
        {
          label: "結束時間",
          name: "EndTime",
          slot_name: "EndTime",
        },
        {
          label: "狀態",
          name: "Status",
        },
        {
          label: "紀錄",
          name: "record",
          slot_name: "record",
        },
      ],
      recordConfig: {
        global_search: {
          visibility: false,
        },

        show_refresh_button: false,
        show_reset_button: false,

        pagination: true,
        pagination_info: false,
        num_of_visibile_pagination_buttons: 5,
        per_page: 5,
        per_page_options: [5],
        selected_rows_info: false,

        highlight_row_hover: false,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
      },
      choiceJobType: "",
    };
  },

  methods: {
    // 分頁
    changePage(queryParams) {
      this.tableInfo = queryParams;
      this.getJobSetting();
    },

    // 取得 排程
    getJobSetting() {
      this.updateLoading(true);
      this.$api.jobSetting
        .getJobSettingPaging({
          isPaging: true,
          page: this.tableInfo.page,
          perPage: this.tableInfo.per_page,
        })
        .then((response) => {
          if (response.status === 200) {
            this.totalData = response.data.Quantity;
            this.rows = response.data.Datas.map((element) => {
              return {
                ...element,
                Status: element.Status === "Running" ? "忙碌" : "閒置",
              };
            });
          }
          this.updateLoading(false);
        });
    },

    // 排程時間設定 Modal
    jobSettingTimeModal(item) {
      this.setting = {
        ...item,
        JobDayOfWeek:
          item.JobDayOfWeek !== null ? item.JobDayOfWeek.split(",") : [],
        JobDayOfMonth:
          item.JobDayOfMonth !== null ? item.JobDayOfMonth.split(",") : [],
      };
    },

    // 手動執行 排程
    executeJobSetting(JobType) {
      this.updateLoading(true);
      this.$api.jobSetting
        .manualExecuteJob({
          createUser: this.$cookies.get("userId"),
          JobType: JobType,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "排程執行成功",
              type: "success",
              duration: 2500,
            });
            this.getJobSetting();
          }
          this.updateLoading(false);
        });
    },

    // 啟用、停用 排程
    updateJobSettingEnabled(job) {
      let message = job.Enabled ? "已啟用排程" : "已停用排程";
      this.updateLoading(true);
      this.$api.jobSetting
        .updateJobSettingEnabled({
          Id: job.Id,
          UpdateUser: this.$cookies.get("userId"),
          Enabled: job.Enabled,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: message,
              type: "success",
              duration: 2500,
            });
            this.getJobSetting();
          }
          this.updateLoading(false);
        });
    },

    // 設定 排程時間
    updateJobSettingTime() {
      this.updateLoading(true);
      this.$api.jobSetting
        .settingJobSettingTime({
          ...this.setting,
          Id: this.setting.Id,
          UpdateUser: this.$cookies.get("userId"),
          JobTimeType: this.setting.JobTimeType,
          JobDayOfWeek:
            this.setting.JobTimeType === "Week"
              ? this.setting.JobDayOfWeek
              : null,
          JobDayOfMonth:
            this.setting.JobTimeType === "Month"
              ? this.setting.JobDayOfMonth
              : null,
          IsRepeatPeriod: this.setting.IsRepeatPeriod,
          JobTimeSpan: this.setting.JobTimeSpan,
          RepeatPeriodMinute: this.setting.RepeatPeriodMinute,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "成功設定排程時間",
              type: "success",
              duration: 2500,
            });
            this.getJobSetting();
          }
          this.updateLoading(false);
        });
    },

    // 取得 所有該排程紀錄
    getJobRecord(JobType) {
      this.updateLoading(true);
      if (this.choiceJobType !== JobType) {
        this.recordDate = this.$common.getToday();
      }
      this.choiceJobType = JobType;
      this.$api.jobSetting
        .getJobRecord({
          jobType: this.choiceJobType,
          date: this.recordDate,
        })
        .then((response) => {
          if (response.status === 200) {
            this.recordList = response.data;
            this.record = {};
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    this.recordDate = this.$common.getToday();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.modal-dialog {
  min-width: 800px;
}

.month {
  display: flex;
  flex-wrap: wrap;

  span {
    width: 40px;
    border-radius: 6px;
    margin-bottom: 1rem;
    text-align: center;
  }

  label {
    margin: 0 4px;
  }
}

.week {
  display: flex;
  flex-wrap: wrap;

  span {
    width: 110px;
    border-radius: 6px;
    margin-bottom: 1rem;
    text-align: center;
  }

  label {
    margin: 0 4px;
  }
}

.col-md-4 {
  border-right: 1px solid #f1f1f1;
}

.form-control {
  margin-bottom: 1rem;
}

.mx-datepicker {
  width: 100%;
  height: 38px;
  margin-bottom: 1rem;
}

label {
  padding: 0;
  margin-right: 3px;
  cursor: pointer;
}
input[type="checkbox"] {
  display: none;
}
input[type="checkbox"] + span {
  display: inline-block;
  background-color: #d3d3d3;
  padding: 3px 6px;
  border: 1px solid gray;
  color: #333;
  user-select: none; /* 防止文字被滑鼠選取反白 */
}

input[type="checkbox"]:checked + span {
  color: #fff;
  background-color: #5380f7;
}

#recordModal .modal-dialog {
  min-width: 900px;
}

.item-type {
  background-color: white;
  color: #33344a;
  padding: 3px 10px;
  position: absolute;
  top: -22px;
  left: 30px;
}

.item-list {
  height: 100%;
  overflow: auto;
  border: 2px solid #33344a;
  border-radius: 5px;
  padding: 10px;
  font-size: 14px;
}

.form-group {
  label {
    font-size: 0.8em;
  }
}

.yahome-table-wrap {
  padding: 0;
}
</style>
